import React, { useState } from 'react';

const CookieSettingsModal = ({ onSave, onAcceptAll, onDeclineAll }) => {
  // Initial state for cookie categories
  // Essential cookies are usually pre-checked and non-toggleable for site function
  const [preferences, setPreferences] = useState({
    analytics: false,
    marketing: false,
    essential: true, // Always true and non-changeable
  });

  const handleToggle = (category) => {
    setPreferences(prev => ({
      ...prev,
      [category]: !prev[category],
    }));
  };
  
  const handleSave = () => {
      // Pass the detailed preferences back to the parent component
      onSave(preferences);
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.content}>
        <h2 style={{ color: '#007bff', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Cookie Preferences</h2>
        <p>Please select which categories of cookies you are happy for us to use. You can change these settings at any time.</p>

        {/* Essential Cookies (Non-Toggleable) */}
        <div style={modalStyles.preferenceGroup}>
          <label style={{ fontWeight: 'bold' }}>
            <input type="checkbox" checked={true} disabled /> Essential Cookies
          </label>
          <p style={modalStyles.description}>Required for the basic functionality of the website and cannot be switched off.</p>
        </div>

        {/* Analytics Cookies (Toggleable) */}
        <div style={modalStyles.preferenceGroup}>
          <label style={{ fontWeight: 'bold' }}>
            <input
              type="checkbox"
              checked={preferences.analytics}
              onChange={() => handleToggle('analytics')}
            /> 
            Analytics & Performance Cookies
          </label>
          <p style={modalStyles.description}>Help us understand how visitors interact with our website (e.g., which pages are most popular).</p>
        </div>
        
        {/* Marketing Cookies (Toggleable) */}
        <div style={modalStyles.preferenceGroup}>
          <label style={{ fontWeight: 'bold' }}>
            <input
              type="checkbox"
              checked={preferences.marketing}
              onChange={() => handleToggle('marketing')}
            /> 
            Marketing & Targeting Cookies
          </label>
          <p style={modalStyles.description}>Used to display relevant ads to you on third-party sites.</p>
        </div>

        <div style={modalStyles.buttonContainer}>
            <button onClick={onDeclineAll} style={{...modalStyles.button, backgroundColor: '#dc3545'}}>
                Decline All
            </button>
            <button onClick={onAcceptAll} style={{...modalStyles.button, backgroundColor: '#28a745'}}>
                Accept All
            </button>
            <button onClick={handleSave} style={{...modalStyles.button, backgroundColor: '#007bff'}}>
                Save Preferences
            </button>
        </div>
      </div>
    </div>
  );
};

// Simple inline styles for the modal
const modalStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
    },
    content: {
        maxWidth: '600px',
        width: '90%',
        padding: '30px',
        borderRadius: '8px',
        backgroundColor: '#fff',
        color: '#333',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    },
    preferenceGroup: {
        border: '1px solid #eee',
        padding: '15px',
        borderRadius: '4px',
        marginBottom: '15px',
    },
    description: {
        fontSize: '14px',
        color: '#666',
        marginTop: '5px',
    },
    buttonContainer: {
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
    },
    button: {
        padding: '10px 15px',
        border: 'none',
        borderRadius: '5px',
        color: 'white',
        cursor: 'pointer',
        fontSize: '15px',
        fontWeight: 'bold',
    }
};

export default CookieSettingsModal;